module.exports = __webpack_public_path__ + "static/media/banner-humanitarian-reset.3ca4850b.png";